export default __webpack_public_path__ + "static/media/gallery_13.09dbd308.jpg";